// Libraries
import React, {useEffect, useState} from "react"
import { connect } from "react-redux"

// Components
import StyledButton from "../../../components/StyledButton/StyledButton"
import StyledDialog from "../../../components/StyledDialog/StyledDialog"

// Structure components
import { Container, Label } from "../../../structureComponents"
import StyledInput from "../../../components/StyledInput/StyledInput";
import StyledSelect from "../../../components/StyledSelect/StyledSelect";
import TeamMember from "../../../models/TeamMember";
import {dispatchUpdateTeamMember} from "../../../store/modules/teamMembers/actions";
import MaskHelper from "../../../utils/MaskHelper";
import StyledRadioGroup from "../../../components/StyledRadioGroup/StyledRadioGroup";
import RxContainer from "../../../structureComponents/modules/Container";
import {neutral500} from "../../../assets/colorPallet";
import StyledAvatar from "../../../components/StyledAvatar/StyledAvatar";


const roles = [
    { label: "Corretor", value: TeamMember.getAllowedRoles().BROKER_ROLE },
    { label: "Atendente", value: TeamMember.getAllowedRoles().ATTENDANT_ROLE }
]

const opportunityRestrictionOptions = [
    { label: "Sim", value: TeamMember.getAllowOpportunityRestrictionValues().APPLY_OPPORTUNITY_RESTRICTION },
    { label: "Não", value: TeamMember.getAllowOpportunityRestrictionValues().ALLOW_ALL_CORPORATIONS }
]

function UpdateTeamMemberDialog({
    active,
    selectedTeamMember,
    updateTeamMember,
    onClose = () => ({})},
) {
    // States
    const [userHasChanges, setUserHasChanges] = useState(false)
    const [loading, setLoading] = useState(false)
    const [teamMember, setTeamMember] = useState(new TeamMember({}))
    const [teamMemberAvatarFile, setTeamMemberAvatarFile] = useState(null)

    // Watchers
    useEffect(() => {
        if (selectedTeamMember) {
            setTeamMember(new TeamMember({
                ...selectedTeamMember
            }))
        }
    }, [selectedTeamMember])

    // Methods
    const handleTeamMemberOnChange = (key, value) => {
        setUserHasChanges(true)
        let _value = value
        if (key === "whatsappNumber") {
            _value = MaskHelper.toPhoneNumber(value)
        }
        setTeamMember(new TeamMember({
            ...teamMember,
            [key]: _value
        }))
    }

    const handleSave = async () => {
        setLoading(true)
        await updateTeamMember({ teamMemberId: selectedTeamMember?.id }, {
            name: teamMember.name,
            lastName: teamMember.lastName,
            email: teamMember.email,
            role: teamMember.role,
            whatsappNumber: teamMember.whatsappNumber,
            opportunityRestriction: teamMember.opportunityRestriction,
            avatarFile: teamMemberAvatarFile
        })

        setLoading(false)
        onClose()
    }

    const handleAvatarOnChange = (selectedFile) => {
        setUserHasChanges(true)
        setTeamMemberAvatarFile(selectedFile)
        setTeamMember(new TeamMember({
            ...teamMember,
            avatarUrl: URL.createObjectURL(selectedFile)
        }))
    }


    return (
        <StyledDialog
            title="Atualizar membro da equipe"
            active={active}
            onClose={() => onClose()}
            maxWidth="sm">
            <Container>
                <Container>
                    <Container fluid flex alignCenter>
                        <RxContainer>
                            <StyledAvatar src={teamMember?.avatarUrl} onChange={handleAvatarOnChange} />
                        </RxContainer>
                        <Container fluid ml="30px">
                            <Container fluid maxWidth="16em">
                                <Label medium bold>Nome</Label>
                                <Container mt="10px">
                                    <StyledInput
                                        placeholder="Digite o nome"
                                        value={teamMember?.name}
                                        onChange={(e) => handleTeamMemberOnChange("name", e.target.value)}/>
                                </Container>
                            </Container>
                            <Container fluid mt="20px">
                                <Label medium bold>Sobrenome</Label>
                                <Container fluid mt="10px">
                                    <StyledInput
                                        fluid
                                        placeholder="Digite o sobrenome"
                                        value={teamMember?.lastName}
                                        onChange={(e) => handleTeamMemberOnChange("lastName", e.target.value)}/>
                                </Container>
                            </Container>
                        </Container>
                    </Container>
                    <Container fluid mt="20px">
                        <Label medium bold>Email</Label>
                        <Container mt="10px">
                            <StyledInput
                            placeholder="Digite o email"
                            value={teamMember?.email}
                            error={!teamMember?.emailIsValid && teamMember?.email?.length > 0}
                            helperText="Somente será aceito um email válido da Imobpro"
                            onChange={(e) => handleTeamMemberOnChange("email", e.target.value)}/>
                        </Container>
                    </Container>
                    <Container fluid mt="20px">
                        <Label medium bold>WhatsApp</Label>
                        <Container mt="10px">
                            <StyledInput
                                placeholder="Digite seu whatsApp"
                                value={teamMember?.whatsappNumber}
                                maxLength={15}
                                error={!teamMember?.whatsappNumberIsValid && teamMember?.whatsappNumber?.length > 0}
                                helperText="Somente será aceito um email válido da Imobpro"
                                onChange={(e) => handleTeamMemberOnChange("whatsappNumber", e.target.value)}/>
                        </Container>
                    </Container>
                    <Container fluid mt="20px">
                        <Label medium bold>Cargo</Label>
                        <Container mt="10px">
                            <StyledSelect
                            items={roles}
                            value={roles.find(role => role.value === teamMember.role)}
                            onChange={(selectedRole) => handleTeamMemberOnChange("role", selectedRole.value)}/>
                        </Container>
                    </Container>
                    <Container fluid mt="20px">
                        <Label medium bold>Restringir vendas apenas para Opportunity?</Label>
                        <Container mt="10px">
                            <StyledRadioGroup
                                value={teamMember?.opportunityRestriction}
                                onChange={(selectionOption) => handleTeamMemberOnChange("opportunityRestriction", selectionOption)}
                                items={opportunityRestrictionOptions} />
                        </Container>
                    </Container>
                </Container>
                <Container mt="40px" flex alignCenter justifyEnd fluid>
                    <Container>
                        <StyledButton kind="primary-outlined" slimHeight onClick={() => onClose()}>
                            Cancelar
                        </StyledButton>
                    </Container>
                    <Container disabled={!teamMember?.hasValidFields && userHasChanges} ml="10px">
                        <StyledButton
                        disabled={!teamMember?.hasValidFields && userHasChanges}
                        loading={loading}
                        kind="primary"
                        slimHeight
                        onClick={handleSave}>
                            Salvar
                        </StyledButton>
                    </Container>
                </Container>
            </Container>
        </StyledDialog>
    )
}


const mapDispatchToProps = (dispatch) => ({
    async updateTeamMember({ teamMemberId }, { name, lastName, email, whatsappNumber, role, opportunityRestriction, avatarFile }) {
        await dispatch(dispatchUpdateTeamMember( { teamMemberId }, {
            name,
            lastName,
            email,
            whatsappNumber,
            role,
            opportunityRestriction,
            avatarFile
        }))
    }
})

export default connect(null, mapDispatchToProps)(UpdateTeamMemberDialog)